import {
  SkeletonPage,
  Layout,
  Card,
  BlockStack,
  SkeletonDisplayText,
  SkeletonBodyText,
} from "@shopify/polaris";
import DataTableSkeleton from "components/datatable/DataTableSkeleton";

const PanelCard = ({ lines }: { lines: number }) => (
  <Card>
    <BlockStack gap="300">
      <SkeletonDisplayText size="small" />
      <SkeletonBodyText lines={lines} />
    </BlockStack>
  </Card>
);

/**
 * Loading placeholder for the business trip detail page. Mirrors the real
 * two-column layout — details / leaves / report / expenses on the left, the
 * three-step generate/sign flow cards on the right — so the page doesn't jump
 * once the trip loads, instead of a bare full-page spinner.
 */
export default function BusinessTripViewSkeleton() {
  return (
    <SkeletonPage fullWidth backAction primaryAction>
      <Layout>
        <Layout.Section>
          <BlockStack gap="500">
            {/* details */}
            <PanelCard lines={8} />
            {/* leaves during trip */}
            <PanelCard lines={3} />
            {/* report data */}
            <PanelCard lines={2} />
            {/* expenses */}
            <Card>
              <BlockStack gap="300">
                <SkeletonDisplayText size="small" />
                <DataTableSkeleton rows={3} columns={5} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <BlockStack gap="500">
            {/* step 1 / 2 / 3 cards */}
            <PanelCard lines={3} />
            <PanelCard lines={3} />
            <PanelCard lines={3} />
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
